import React from 'react';
import './ProgressDialog.css';
import { observer } from 'mobx-react';

interface ProgressDialogProps {
	open: boolean;
	progress: number;
	total: number;
	messageFunc: (progress: number, total: number) => string;
	title: string;

	colorTheme?: 'light' | 'dark';
}

function ProgressDialog({ open, progress, total, messageFunc, title, colorTheme }: ProgressDialogProps) {
	if (!open) return null;

	const percentage = total > 0 ? (progress / total) * 100 : 0;
	const message = messageFunc(progress, total);

	return (
		<div className="progress-dialog-overlay">
			<div className="progress-dialog">
				<div className="progress-title">{title}</div>
				<div className="progress-message">{message}</div>
				<div className="progress-bar-container">
					<div
						className="progress-bar"
						style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
					/>
				</div>
			</div>
		</div>
	);
}

export default observer(ProgressDialog);